module.exports = __webpack_public_path__ + "src/assets/individualImages/honeyBeeWorkerSkinViolet.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/honeyBeeWorkerSkinViolet.png
// module id = ./src/assets/individualImages/honeyBeeWorkerSkinViolet.png
// module chunks = 0